import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export const userId = state => {
    return state.userId;
};

export const maskOfNumber = state => {
    return createNumberMask({
        prefix: '',
        thousandsSeparatorSymbol: state.locale === 'tr' ? '.' : ',',
        allowDecimal: true,
        decimalSymbol: state.locale === 'tr' ? ',' : '.',
        decimalLimit: 2
    });
};
export const maskOfCurrency = state => {
    return createNumberMask({
        prefix: '',
        thousandsSeparatorSymbol: state.locale === 'tr' ? '.' : ',',
        allowDecimal: true,
        allowNegative: true,
        decimalSymbol: state.locale === 'tr' ? ',' : '.',
        decimalLimit: 2
    });
};

// Masks emission values and adds unit type suffix
export const maskOfEmission = state => {//(suffix) => {
    return createNumberMask({
        prefix: '',
        //suffix: ` ${suffix}`,
        thousandsSeparatorSymbol: state.locale === 'tr' ? '.' : ',',
        allowDecimal: true,
        decimalSymbol: state.locale === 'tr' ? ',' : '.',
        decimalLimit: 16,
        integerLimit: 3
    });
};



// WEBPACK FOOTER //
// ./src/store/getters.js